import React, { useContext, useState } from "react";
import { TextField, Button, Box, Typography, Container } from "@mui/material";
import './EmailForm.css'
import UserContext from "../../Context/User/userContext";
import Swal from "sweetalert2";
import axios from "axios";

function EmailForm() {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : ""

  // User Object
  const { user, setUser } = useContext(UserContext);
  const userObj = user && (typeof user === 'string' ? JSON.parse(user) : user);

  const handleSubmit = (event) => {
    event.preventDefault();

    const emailObj = {
      body: message,
      sub: subject,
      managerName: `${userObj.firstName} ${userObj.lastName}`,
      userEmail: email,
    }

    if (email && subject && email) {
      axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/email`, emailObj, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenValue}`
          // You can add other headers if needed like authorization token, etc.
        }
      })
        .then(res => {
          Swal.fire({
            icon: "success",
            title: "Sent...",
            text: 'Email has been sent',
            customClass: {
              container: 'swal2-container-custom'
            }
          });
          setEmail('');
          setMessage('');
          setSubject('');
        })
        .catch(error => {
          console.error("Error:", error.response.data.message);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Fill out all fields',
        customClass: {
          container: 'swal2-container-custom'
        }
      });
    }
  };


  return (
    <div className="email-dialog">
      <Container maxWidth="sm">
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            required
            id="email"
            label="To"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            required
            id="subject"
            label="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <TextField
            required
            id="message"
            label="Message"
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Button type="submit" variant="contained" style={{backgroundColor:'#178383'}}>
            Send
          </Button>
        </Box>
      </Container>
    </div>
  );
}

export default EmailForm;
